// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Text__Jsx3 = require("./Text__Jsx3.bs.js");

function PseudoJoin(props) {
  var with_ = props.with_;
  var as_ = props.as_;
  var as_$1 = as_ !== undefined ? as_ : "span";
  var with_$1 = with_ !== undefined ? with_ : " / ";
  var className = React.useMemo((function () {
          return Curry._1(Css.style, {
                      hd: Css.focus({
                            hd: Css.outlineStyle("none"),
                            tl: /* [] */0
                          }),
                      tl: {
                        hd: Css.selector("& > *:not(:last-child)", {
                              hd: Css.after({
                                    hd: Css.contentRule({
                                          NAME: "text",
                                          VAL: with_$1
                                        }),
                                    tl: {
                                      hd: Css.whiteSpace("preWrap"),
                                      tl: /* [] */0
                                    }
                                  }),
                              tl: /* [] */0
                            }),
                        tl: /* [] */0
                      }
                    });
        }), [with_$1]);
  return React.createElement(Text__Jsx3.make, {
              as_: as_$1,
              className: className,
              children: props.children
            });
}

var make = PseudoJoin;

exports.make = make;
/* Css Not a pure module */
